import React from "react";

const ErrorPage = () => {
	return <div>Oh no! Something went wrong!</div>;
};

export default ErrorPage;
